import { ReactNode, useEffect } from 'react';
import { getUser, isWeaveUser } from '@frontend/auth-helpers';
import { TaskCenterProviderContext } from '@frontend/task-center-scope';
import { useGetContextValues, useNotifications } from '../hooks';

export const TaskCenterProvider = ({ children }: { children: ReactNode }) => {
  const contextValue = useGetContextValues();
  useNotifications({
    onViewNotification: contextValue.onViewNotification,
  });

  useEffect(() => {
    // Re-setting the other filters when location changes
    contextValue.resetSelectedFilters();
  }, [contextValue.locationsData, contextValue.resetSelectedFilters]);

  useEffect(() => {
    // Setting this as assignee filter here because getUser returns undefined on the first render
    if (!isWeaveUser()) {
      contextValue.setAssigneeFilter?.(getUser()?.userID ?? '');
    }
  }, [getUser, isWeaveUser]);

  return <TaskCenterProviderContext.Provider value={contextValue}>{children}</TaskCenterProviderContext.Provider>;
};
